import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedWorkCalendarsRecordsProjectIds } from '../selectors/selectedRecords.selectors';
import { postApproveMultipleRecords } from '../services/postApproveMultipleRecords.service';
import { selectSelectedRecordsIds } from '../selectors/records-base.selectors';

export const approveMultipleRecords = createAsyncThunk(
  'records/approveMultipleRecords',
  async (_, { getState }) => {
    const selectedRecordIds = selectSelectedRecordsIds(getState());

    const selectedRecordProjectIds =
      selectSelectedWorkCalendarsRecordsProjectIds(getState());

    const response = await postApproveMultipleRecords(
      selectedRecordProjectIds,
      selectedRecordIds
    );

    return response;
  }
);
